import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[floNumber]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: NumberDirective, multi: true },
    ],
})
export class NumberDirective {
    @Input() public allowDecimals: boolean = true;
    @Input() public allowNegatives: boolean = false;
    @Input() public requireGreaterThanZero: boolean = false;
    private formControl: FormControl;
    /* eslint-disable */
    DECIMAL_REGEXP = /^[0-9]+(\.[0-9]+)?$/i;
    DECIMAL_NEG_REGEXP = /^-?[0-9]+(\.[0-9]+)?$/i;
    INT_REGEXP = /^\d+$/;
    INT_NEG_REGEXP = /^-?\d+$/;

    public validate(control: FormControl): { [s: string]: boolean } {
        this.formControl = control;

        if (control.value) {
            if (this.allowDecimals) {
                const regex: any = this.allowNegatives ? this.DECIMAL_NEG_REGEXP : this.DECIMAL_REGEXP;
                if (!regex.test(control.value)) {
                    return { 'invalidDecimal': true };
                }
            } else {
                const regex: any = this.allowNegatives ? this.INT_NEG_REGEXP : this.INT_REGEXP;
                if (!regex.test(control.value)) {
                    return { 'invalidNumber': true };
                }
            }
        }

        if (this.requireGreaterThanZero && parseFloat(control.value) <= 0) {
            return { 'invalidLessThanZero': true };
        }

        return null;
    }
}
